import BaseModalForm from 'components/BaseModalForm'
import _ from 'lodash';
import React, { useCallback, useMemo, useState } from 'react'
import ImpervaAPI from 'restAPI/ImpervaAPI';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';

const BASIC_AUTH = "USERNAME_PASSWORD", TOKEN_AUTH = "TOKEN";

const CONFIG_PROPERTIES = ["end_point", "frequency", "search_key"];
const ROOT_PROPERTIES = ["authMode", "password", "username", "token", "name", "enabled"];

const ImpervaConfigFormPopup = React.forwardRef(function ImpervaConfigFormPopup(props, ref) {
    const [success, setSuccess] = useState(false);
    const [initialValues] = useState(() => {
        return {
            source: "splunk",
            authMode: BASIC_AUTH,
            ..._.pick(props.data?.configs, CONFIG_PROPERTIES),
            ..._.pick(props.data, ROOT_PROPERTIES),
            frequency: parseInt(props.data?.configs?.frequency) || 1,
        }
    });
    const editId = props.data?.id;
    const [authMode, setAuthMode] = useState(initialValues.authMode);
    const onOk = useCallback((values) => {
        values.frequency += " HOURS";
        const data = {
            id: editId,
            configs: _.pick(values, CONFIG_PROPERTIES),
            ..._.pick(values, ROOT_PROPERTIES),
            enabled: initialValues.enabled
        }
        return ImpervaAPI.createOrUpdateConfig(data).promise.then(() => setSuccess(true));
    }, [editId, initialValues.enabled]);
    const onValuesChange = useCallback((values) => {
        if(values.authMode){
            setAuthMode(values.authMode);
        }
    }, []);
    const fields = useMemo(() => {
        const fields = [{
            name: "name",
            label: "Configuration Name",
            required: true,
            colSpan: 12,
            props: {
                autoFocus: true
            }
        }, {
            name: "source",
            label: "Enterprise data source",
            type: FieldTypes.SELECT,
            options: [{ value: "splunk", label: "Splunk" }],
            colSpan: 12
        }, {
            name: "end_point",
            label: "Endpoint",
            required: true,
            colSpan: 12,
            rules: [urlRegexValidator()]
        }, {
            name: "index_name",
            label: "Index Name",
            required: true,
            colSpan: 12,
        }, {
            name: "search_key",
            label: "Search key",
            required: true,
            colSpan: 14
        }, {
            name: "frequency",
            label: "Sync frequency",
            placeholder: "Frequency",
            type: FieldTypes.NUMBER,
            min: 1,
            max: 24,
            required: true,
            colSpan: 10,
            props: {
                addonAfter: "Hours"
            }
        }, {
            name: "authMode",
            label: "Auth type",
            type: FieldTypes.RADIO,
            options: [{label: "Basic Auth", value: BASIC_AUTH}, {label: "Token Auth", value: TOKEN_AUTH}]
        }]

        if(authMode === BASIC_AUTH){
            fields.push({
                name: "username",
                label: "Username",
                required: true,
                colSpan: 12
            }, {
                name: "password",
                label: "Password",
                type: FieldTypes.PASSWORD,
                required: true,
                colSpan: 12
            })
        } else {
            fields.push({
                name: "token",
                label: "Token",
                type: FieldTypes.PASSWORD,
                required: true,
            })
        }
        return fields;
    }, [authMode]);
    return (
        <BaseModalForm
            ref={ref}
            title={`${editId ? "Edit" : "Add"} Imperva Configuration`}
            onOk={onOk}
            fields={fields}
            onValuesChange={onValuesChange}
            initialValues={initialValues}
            afterClose={() => props.afterClose(success)}
        />
    )
})

export default ImpervaConfigFormPopup;